import React, { Component } from "react"
import { connect } from "react-redux"
import { Link } from "react-router-dom"
import { compose } from "redux"
import { createStructuredSelector } from "reselect"

import * as ROUTES from "config/routes"
import { withClientId } from "hocs"
import { wsClient } from "index"
import { bem, comparePropertiesGraded } from "utils/helpers"
import {
  blockAttendanceByHolderSelector,
  detAttBlockByHolderLoadingSelector
} from 'redux/selectors'
import { getBlockAttendanceByHolder } from "redux/modules/model/attendance"

import { Select, Table } from 'elements'

import "./index.scss"

const em = (e, m) => bem("block-assignments", e, m)

const attendanceStatuses = [
  "absent",
  "auth-absent",
  "present"
]

class BlockAssignments extends Component {

  constructor (props) {
    super(props)
    this.state = {
      scheduleHolderAssignments: [],
      data: [],
      loading: false
    }
  }

  assertOverrideAttendanceBuffer = (clientReference, status) => {
    const { overrideAttendanceBufferStateCallback } = this.props
    this.setState((state) => {
      const overrideAttendanceBuffer = {
        ...state.overrideAttendanceBuffer,
        [clientReference]: status
      }
      overrideAttendanceBufferStateCallback(overrideAttendanceBuffer)
      return {overrideAttendanceBuffer}
    })
  }

  clearOverrideAttendanceBuffer = () => {
    const { overrideAttendanceBufferStateCallback } = this.props
    this.setState(() => {
      const overrideAttendanceBuffer = {}
      overrideAttendanceBufferStateCallback(overrideAttendanceBuffer)
      return {overrideAttendanceBuffer}
    })
  }

  columns = () => {
    const { edit, scheduleId } = this.props
    return [
      {
        title: "Name",
        dataIndex: "name",
        render: (text, record) => (
          <Link to={
            ROUTES.ATTENDANCE_SCHEDULES_BLOCK_DRILLDOWN
              .replace(':scheduleId', scheduleId)
              .replace(':clientReference', record.clientReference)
          }>
            {text}
          </Link>
        ),
        sorter: (a, b) => comparePropertiesGraded(a, b, "name")
      },
      {
        title: "Attendance",
        dataIndex: "status",
        sorter: (a, b) => comparePropertiesGraded(a, b, "status")
      }
    ]
  }

  componentDidMount = () => {
    const { clientId, scheduleId, blockId } = this.props
    this.clearOverrideAttendanceBuffer()
    // this.getBlockAttendanceByHolder(clientId, scheduleId, blockId)
    this.props.getBlockAttendanceByHolder({clientId, scheduleId, blockId})
  }

  getBlockAttendanceByHolder = async (clientId, scheduleId, blockId) => {
    this.setState({loading: true})
    const response = await wsClient.request({
      messageType: 'attendance.schedule.list-block-attendance-records',
      payload: {
        clientId,
        scheduleId,
        blockId
      }
    })
    response.payload &&
      this.setState(() => ({
        data: [...response.payload],
        loading: false
      }))
  }

  render = () => {
    const { edit, data, loading } = this.props
    const dataSource = data.map((item) => ({
      clientReference: item.clientReference,
      name: item.holderName || `#${item.clientReference}`,
      status: (() => {
        const status = item.status
        return edit
          ? <Select
            className={em("attendance-selector")}
            defaultValue={status}
            onChange={(value) => {
              this.assertOverrideAttendanceBuffer(item.clientReference, (value === status) ? undefined : value)
            }}
          >
            {attendanceStatuses.map((attendanceStatus) => (
              <Select.Option key={attendanceStatus} value={attendanceStatus}>{attendanceStatus}</Select.Option>
            ))}
          </Select>
          : status || "---"
      })()
    })).sort((a, b) => comparePropertiesGraded(a, b, "name", "status"))
    return (
      <Table
        className={em("table")}
        loading={loading}
        dataSource={dataSource}
        columns={this.columns()}
        pagination={false}
        rowKey="name"
      />
    )
  }

}

export const selectors = createStructuredSelector({
  data: blockAttendanceByHolderSelector,
  loading: detAttBlockByHolderLoadingSelector,
})
export const actions = {
  getBlockAttendanceByHolder,
}

export default compose(
  withClientId,
  connect(selectors, actions),
)(BlockAssignments)



// WEBPACK FOOTER //
// ./src/pages/attendance/attendance-schedule-detail/components/block-info/components/block-assignments/index.js